import CeremonyBackground from './CeremonyBackground';
import BrandLogo from './BrandLogo';

/**
 * Shared page frame (background + corner brand mark + centered content
 * column) used by both the ceremony page itself and the invalid-link
 * fallback, so every state — loading, error, success — renders inside the
 * same premium shell instead of a plain/blank page.
 *
 * BrandLogo is rendered as a sibling of `.ceremony-page__content`, not a
 * child inside it — it's positioned via `.ceremony-brand`'s own
 * `position: fixed` corner placement (see ceremony-components.css), so it
 * doesn't take up space in the centered flex column or shift the guest's
 * name/status content.
 */
export default function CeremonyShell({ children }) {
  return (
    <div className="ceremony-page">
      <CeremonyBackground />
      <BrandLogo />
      <main className="ceremony-page__content">{children}</main>
    </div>
  );
}
